import CustomIcons from "../GlobalComponents/CustomIcons";
import React, { Component } from "react";
import settings from "../../settings";
import FetchResponses from "../../models/FetchResponses";
import Auth from "../../models/Auth";
import Icon from "../GlobalComponents/Icon";
import ReactHtmlParser from "react-html-parser";

class Benefits extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activo: "first",
      bloque1: {
        titulo: '',
        imagen: '',
        data: []
      },
      bloque2: {
        titulo: '',
        imagen: '',
        data: []
      },
      cards: {},
      soloUna: false
    };
  }

  

  toggle = () => {
    if(this.state.soloUna) return
    this.setState((prevState) => ({
      activo: prevState.activo === "first" ? "second" : "first",
    }));
  };

  componentDidMount() {
    this.getBenefits()
  }

  componentWillUnmount() {}

  getBenefits() {
    let url = settings.backend.benefits;
    fetch(url, {
      method: "GET",
    }).then(FetchResponses.processResponse)
      .then((response) => {

        const bloque1 = response.find(item => item.name === 'bloque1');
        const bloque2 = response.find(item => item.name === 'bloque2');

        let cards = {
          first:  bloque2.data.opciones[0],
          second: bloque2.data.opciones[1]
        }
        
        let soloUna = !cards.first.activo || !cards.second.activo
        let activo = 'first'

        if(soloUna && !cards.first.activo) {
            activo = 'second'
        }

        this.setState({bloque1, bloque2, cards: cards, soloUna, activo})
      }).catch(this.failureDataResponse);
  }

  render() {
    const { activo } = this.state;

    return (
      <div className="benefits-section">
        <div className="benefits-section__card--container">
          <div
            className="benefits-section__card--image"
            style={{
              backgroundImage: `url('${this.state.bloque1.imagen}')`,
            }}
          ></div>
          <div className="benefits-section__card">
            <p className="benefits-section__card--title">
              {this.state.bloque1.titulo}
            </p>
            <ul className="benefits-section__card--content">
              {this.state.bloque1.data.beneficios && this.state.bloque1.data.beneficios.map((beneficio) => {
                return (
                  <li>
                    <CustomIcons
                      className="benefits-section__card--content--icon"
                      icon="iconCheck"
                    />
                    {beneficio.texto}
                  </li>
                );
              })}
            </ul>
          </div>
        </div>

        <div className="benefits-section__steps--container">
          <h2 class="card-carousel__maintitle benefits">{this.state.bloque2.titulo}</h2>
          <div
            className="benefits-section__toggle-container"
            onClick={this.toggle}
          >
            
            { !this.state.soloUna  && <div
              className={`benefits-section__toggle-indicator ${activo}`}
            ></div> }
            
            {
              this.state.cards.first && this.state.cards.first.activo &&
              <div className="benefits-section__toggle-option">{this.state.cards.first.titulo}</div>
            }
            {
              this.state.cards.second && this.state.cards.second.activo &&
              <div className="benefits-section__toggle-option">{this.state.cards.second.titulo}</div>
            }
          </div>
          <p className="benefits-section__toggle-title">
            {this.state.bloque2.titulo}
          </p>
          <br></br>
          <div className="benefits-section__toggle-cards">
            {this.state.cards[activo] && this.state.cards[activo].pasos.map((card, index) => (
              <div key={index} className="benefits-section__toggle-card">
                <Icon
                  className="benefits-section__card-icon"
                  name={card.icono}
                  size={16}
                />
                <div className="benefits-section__toggle-card-content ">
                  <span className="benefits-section-card-content__order">
                    {index + 1}
                  </span>
                  <p className="benefits-section-card-content__text">
                    {ReactHtmlParser(card.texto)}
                  </p>
                </div>
              </div>
            ))}
          </div>
          <a href="https://www.credito20minutos.com/mainpage/25" className="benefits-section__toggle-button">
            Más Información
          </a>
        </div>
      </div>
    );
  }
}

export default Benefits;
